import React, { memo, useCallback, useState } from 'react';
import { Layout } from 'fronton-react';
import { css } from 'linaria';
import { analyticsUtils } from 'utils/analytics-utils';
import { Button, ButtonProps } from '../../../button';
import { MobileFixedPanelModal } from './mobile-fixed-panel-modal';
import { MobileFixedPanelStructure } from './mobile-fixed-panel-types';

type MobileFixedPanelProps = {
  structure: MobileFixedPanelStructure;
};

export const mobileFixedPanel = css`
  display: none;

  @media (--only-mobile) {
    display: block;
  }
`;

export const MobileFixedPanel = memo(({ structure }: MobileFixedPanelProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { onClick, openModal, label, elementBlock, ...rest } = structure.mobileButton;

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleDesignBtnClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (elementBlock) {
        analyticsUtils.clickButtonEvent(elementBlock, 'sticky-panel-mobile', label);
      }

      if (openModal) {
        setIsModalOpen(true);
        return;
      }

      if (onClick) onClick(e);
    },
    [elementBlock, label, onClick, openModal]
  );

  return (
    <Layout className={mobileFixedPanel}>
      <Button
        adaptive={false}
        onClick={handleDesignBtnClick}
        variant="accent"
        wide
        {...(rest as ButtonProps)}>
        {structure.mobileButton.label}
      </Button>

      <MobileFixedPanelModal isOpen={isModalOpen} onClose={handleCloseModal} structure={structure} />
    </Layout>
  );
});
